import { render, staticRenderFns } from "./meta-languages-field.vue?vue&type=template&id=ca8ca746&scoped=true&"
import script from "./meta-languages-field.vue?vue&type=script&lang=js&"
export * from "./meta-languages-field.vue?vue&type=script&lang=js&"
import style0 from "./meta-languages-field.vue?vue&type=style&index=0&id=ca8ca746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8ca746",
  null
  
)

export default component.exports